var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgCheckedCircle = function SvgCheckedCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 0C114.837 0 0 114.843 0 256s114.837 256 256 256 256-114.843 256-256S397.163 0 256 0m120.239 227.501-118.891 118.89c-13.043 13.043-34.174 13.044-47.218 0l-68.804-68.804c-13.044-13.038-13.044-34.179 0-47.218 13.044-13.044 34.174-13.044 47.218 0l45.195 45.19 95.282-95.278c13.044-13.044 34.174-13.044 47.218 0 13.044 13.04 13.044 34.181 0 47.22"
  })));
};
var Memo = /*#__PURE__*/memo(SvgCheckedCircle);
export default Memo;